import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePathname } from "../../../shared/usePathname";
import { privatePagesMap } from "../router/privatePagesMap";
import { useSelector } from "react-redux";

const item = (key, { parent } = {}) => ({
  key: parent ? `${parent}${key}` : key,
  icon: privatePagesMap[key].icon,
  label: privatePagesMap[key].label,
});

const attachPaths = (nodes, base = "") =>
  nodes.filter(Boolean).map((n) => {
    const key = base ? `${base}${n.key}` : n.key;
    const out = { ...n, key };
    if (n.children) out.children = attachPaths(n.children, key);
    return out;
  });

const rawMenu = (isAdmin) => [
  { ...item("/dashboard") },
  {
    ...item("/applications"),
    children: [item("/search"), item("/quote")],
  },
  {
    ...item("/renewals"),
    children: [item("/search"), item("/email-template")],
  },
  isAdmin && { ...item("/users") },
];

const specialCases = {
  "/applications/view": "/applications/search",
  "/applications/edit": "/applications/search",
  "/renewals/view": "/renewals/search",
  "/renewals/edit": "/renewals/search",
  "/renewals/send-email": "/renewals/search",
  "/renewals/view-previous-quote": "/renewals/search",
};

const SideMenu = () => {
  const { subpaths } = usePathname();
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [collapsedWidth, setCollapsedWidth] = useState(80);
  const [broken, setBroken] = useState(false);

  const openKeys = [subpaths[0]];
  const selectedKeys = useMemo(() => {
    if (subpaths.length > 1) {
      var path = subpaths[0] + subpaths[1];
      return [specialCases[path] ?? path];
    }
    return [subpaths[0]];
  }, [subpaths]);

  const isAdmin = useSelector((state) => state.user.admin);
  const menuItems = useMemo(() => attachPaths(rawMenu(isAdmin)), [isAdmin]);

  return (
    <Layout.Sider
      collapsible
      className="main-side-menu"
      collapsedWidth={collapsedWidth}
      collapsed={collapsed}
      breakpoint="md"
      onBreakpoint={(b) => {
        setBroken(b);
        setCollapsed(b);
        setCollapsedWidth(b ? 0 : 80);
      }}
      zeroWidthTriggerStyle={{
        backgroundColor: "#ffffff",
        background: "#ffffff",
        border: "1px solid #d5dde6",
        top: "auto",
        bottom: "184px",
      }}
      onCollapse={(_) => {
        if ((!broken && collapsed) || (broken && collapsedWidth === 0)) {
          if (broken) {
            setCollapsedWidth(80);
          } else {
            setCollapsed(!collapsed);
          }
        } else {
          if (broken) {
            setCollapsedWidth(0);
          } else {
            setCollapsed(!collapsed);
          }
        }
      }}
      trigger={
        (!broken && collapsed) || (broken && collapsedWidth === 0) ? (
          <RightOutlined className="main-sider-menu-trigger" />
        ) : (
          <LeftOutlined className="main-sider-menu-trigger" />
        )
      }
    >
      <Menu
        className="sider-menu-component"
        onClick={({ key }) => {
          navigate(key);
        }}
        defaultSelectedKeys={selectedKeys}
        defaultOpenKeys={openKeys}
        selectedKeys={selectedKeys}
        mode="inline"
        items={menuItems}
      />
    </Layout.Sider>
  );
};

export default SideMenu;
